import React, { useEffect, useState } from 'react'
import Input from 'components/Input'
import { filterValues } from 'Helper'
import { withTranslation } from 'react-i18next'
import useSWR from 'swr'


export default withTranslation()(function AddPOS({ t }) {
  const { data: Branches } = useSWR('merchants/branches?page=1&page-size=200')
  const { data: user_id } = useSWR('pos/available-users')

  const [branches, setBranches] = useState(null)
  const [userId, setUserId] = useState(null)

  useEffect(() => {
    if (Branches?.data) setBranches(Branches.data.data)
    if (user_id) setUserId(user_id.data)
  }, [Branches, user_id]);



  const fields = [
    {
      name: 'name',
      placeholder: t('pos.form.name.placeholder'),
      hidden: false,
      label: t('pos.form.name.label')
    },
    {
      name: 'branch_id',
      hidden: false,
      label: t('pos.form.select'),
      options: branches ? filterValues({ options: branches, param: { label: 'name', value: 'id' } }) : []
    },
    {
      name: 'user_id',
      hidden: false,
      label: 'User',
      placeholder: 'Select User',
      options: userId ? filterValues({ options: userId, param: { label: 'name', value: 'id' } }) : []
    }
  ]


  // console.log('Merchant branches', branches)

  return (
    <>
      {
        <>
          {
            fields.map(field => {
              return (
                <React.Fragment key={field.name}>
                  {
                    <div className={`mb-5 `} >
                      <Input
                        name={field.name}
                        label={field.label}
                        options={field?.options}
                        variant="filled"
                        placeholder={field?.placeholder}
                        classList={"bg-default rounded-md p-2.5"}
                      />
                    </div>
                  }
                </React.Fragment>
              )
            })
          }
        </>
      }
    </>
  )
})